import { ReactNode, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { trim } from "../../utils/trim";

interface HeaderDropdownMenuProps {
  label: string;
  items:
    | {
        link: string;
        label: string;
        imageUrl?: string | undefined;
        icon?: ReactNode;
      }[]
    | undefined;
}

const HeaderDropdownMenu: React.FC<HeaderDropdownMenuProps> = ({
  label,
  items,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const ref = useRef<HTMLLIElement | null>(null);
  const navigate = useNavigate();

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (ref.current && !ref.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("click", handleClickOutside, true);
    return () => {
      document.removeEventListener("click", handleClickOutside, true);
    };
  }, []);

  return (
    <li
      className={trim(`header_link ${isOpen ? "header_link--active" : ""}`)}
      ref={ref}
      onClick={() => setIsOpen(!isOpen)}
      role="button"
      tabIndex={0}
      onKeyDown={(event) => {
        if (event.key === "Enter" || event.key === " ") {
          event.preventDefault();
          setIsOpen((open) => !open);
        }
      }}
    >
      <p>{label}</p>

      {isOpen && (
        <ul className="header_dropdown">
          {items?.map(({ link, label: itemLabel, imageUrl, icon }, index) => (
            <li
              onClick={(event) => {
                event.stopPropagation();
                navigate(link);
                setIsOpen(false);
              }}
              key={index}
              role="link"
              tabIndex={0}
              onKeyDown={(event) => {
                if (event.key === "Enter" || event.key === " ") {
                  event.preventDefault();
                  navigate(link);
                  setIsOpen(false);
                }
              }}
            >
              <span>
                {icon}
                {imageUrl && <img src={imageUrl} alt={itemLabel} />}
                <span>{itemLabel}</span>
              </span>
            </li>
          ))}
        </ul>
      )}
    </li>
  );
};

export default HeaderDropdownMenu;
